import i18n from '@/locales'

export default {
  data () {
    return {
      invoiceAddressProps: {
        list: this.$list.createList(this, {
          resource: 'billing_invoice_addresses',
        }),
        columns: [
          {
            field: 'recipient',
            title: i18n.t('scope.text_708'),
            minWidth: 80,
          },
          {
            field: 'address',
            title: i18n.t('scope.text_709'),
            minWidth: 120,
            showOverflow: 'ellipsis',
            slots: {
              default: ({ row }, h) => {
                const text = row.province + row.city + row.district + row.street + row.address
                return [
                  <span title={text}>{text}</span>,
                ]
              },
            },
          },
          {
            field: 'phone',
            title: i18n.t('scope.text_494'),
            minWidth: 80,
          },
          {
            field: 'status',
            title: i18n.t('scope.text_426'),
            minWidth: 70,
          },
        ],
      },
    }
  },
}
